
import stampit from 'stampit'
const Firestore = stampit({
  name: 'Firestore',
  props: {
    firestore: null
  },
  init ({firestore}) {
    this.firestore = firestore || {}
  },
  statics: {
    isMoreRecentThan: function (primary, other) {
      if (!primary || !primary.firestore || !primary.firestore.modified || primary.firestore.modified.seconds === undefined || primary.firestore.modified.nanoseconds === undefined) {
        console.warn('invalid firestore data in isMoreRecentThan ')
        return true
      }
      if (!other || !other.firestore || !other.firestore.modified || other.firestore.modified.seconds === undefined || !other.firestore.modified.nanoseconds === undefined) {
        console.warn('invalid firestore data in isMoreRecentThan comparison')
        return false
      }
      if (primary.firestore.modified.seconds > other.firestore.modified.seconds) {
        return true
      } else if (primary.firestore.modified.seconds < other.firestore.modified.seconds) {
        return false
      }
      return primary.firestore.modified.nanoseconds > other.firestore.modified.nanoseconds
    },
    createdMoreRecentThan: function (primary, other) {
      if (!primary || !primary.firestore || !primary.firestore.created || !primary.firestore.created.seconds || !primary.firestore.created.nanoseconds) {
        return false
      }
      if (!other || !other.firestore || !other.firestore.created || !other.firestore.created.seconds || !other.firestore.created.nanoseconds) {
        return true
      }
      if (primary.firestore.created.seconds > other.firestore.created.seconds) {
        return true
      } else if (primary.firestore.created.seconds < other.firestore.created.seconds) {
        return false
      }
      return primary.firestore.created.nanoseconds > other.firestore.created.nanoseconds
    }
  },
  methods: {

  }
})
export default Firestore



// WEBPACK FOOTER //
// ./src/tts/firestore.js